import React, { Component } from "react";
import Dialog from "../../dialog";

import Graph from "./graphenode.js";


import { GlobalContext } from "../../../../utils/globalprovider.js";

import { apiReadOneVideo, ApiPostKillWorker, ApiPostRestartWorker, ApiPostToDoWorker, ApiPostCancelWorker } from "../../../../utils/apis";

import play from "./assets/play.png"
import stop from "./assets/stop.png"
import cancel from "./assets/cancel.png"



import "./graphvideo.css"

class GraphVideo extends Dialog
{
  static contextType = GlobalContext;

  constructor(props) 
  {
    super(props);



    const title = {
        en:"Workers Video Graph", 
        fr:"Graphe traitements vidéo",
      };
    this.state.title = title;

    this.timer = null;
    this.firstRead = true;
    

    this.state.buttons = 
    [
      {type:"back", disabled:false},
    ]

    this.onQuit = this.onQuit.bind(this)

    this.state.video = null;

        this.state.nodes = [

            {
                id: "download",
                title: {fr:"Téléversement",en:"Upload"},
                titleColor: "#303030",

                content: [
                ],

                buttons: {
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: [
                    "analyse"
                ]
            },


            {
                id: "analyse",

                title: {fr:"Analyse Fichier",en:"File Anlasyse"},

                titleColor: "#303030",

                content: [
                ],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true,
                    },

                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: [
                    "conversion"
                ]
            },


            {
                id: "conversion",

                title: {fr:"Conversion MP4",en:"MP4 Conversion"},

                titleColor: "#303030",

                content: [
                ],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true
                    },

                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: [
                    "audio",
                    "changements",
                    "recherche"
                ]
            },


            {
                id: "audio",

                title: {fr:"Traitement Audio",en:"Audio Processing"},

                titleColor: "#303030",

                content: [
                ],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true
                    },


                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: [
                    "transcription"
                ]
            },


            {
                id: "changements",

                title: {fr:"Changements de plan",en:"Shots scanning"},

                titleColor: "#303030",

                content: [
                ],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true
                    },

                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: []
            },


            {
                id: "recherche",

                title: {fr:"Recherche des Textes",en:"Texts Scanning"},

                titleColor: "#303030",

                content: [],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true
                    },


                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: []
            },


            {
                id: "transcription",

                title: {fr:"Transcription",en:"Transcription"},

                titleColor: "#303030",

                content: [],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true,
                        title: {fr:"Relancer avec Speechmatics",en:"Restart with Speechmatics"}
                    },

                    play2: {
                        image: play,
                        visible: true,
                        disabled: true,
                        title: {fr:"Relancer avec DAIA",en:"Restart with DAIA"}
                    },

                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: [
                    "scenario"
                ]
            },


            {
                id: "scenario",

                title: {fr:"Scénario",en:"Scenario"},

                titleColor: "#303030",

                content: [
                ],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true
                    },

                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type: "text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: [
                    "simplifier"
                ]
            },


            {
                id: "simplifier",
                title: {fr:"Simplifieur",en:"Simplifier"},
                titleColor: "#303030",

                content: [
                ],

                buttons: {

                    play1: {
                        image: play,
                        visible: true,
                        disabled: true
                    },


                    stop: {
                        image: stop,
                        visible: true,
                        disabled: true
                    },

                    annuler: {
                        image: cancel,
                        visible: true,
                        disabled: true
                    }
                },

                footer: {
                    type:"text",
                    text: {fr:"Etat inconnu",en:"Unknown state"},
                    color: "#ffffff"
                },

                next: []
            }

        ];

   


    this.videoReadCallBack = this.videoReadCallBack.bind(this);
    this.onKillWorkerReturn = this.onKillWorkerReturn.bind(this);
    this.handleButton =  this.handleButton.bind(this);


    }

  /*
                      type: "progress",
                    value: 10,
                    progressColor: "#008000"

  */


    componentWillUnmount()
    {
      super.componentWillUnmount();
      if (this.timer) clearTimeout(this.timer);
      this.timer = null;

      

    }

  componentDidMount()
  {

      super.componentDidMount();
      // on fait une premiere lecture du fichier vidéo
      console.log("viid : ", this.props.viid)
      if (this.firstRead) apiReadOneVideo ({viid: this.props.viid}, this.videoReadCallBack);
      this.firstRead=false;
  }


/* 
    download,
    analyse,
    audio,
    changements
    recherche
    transcription,
    scenario
    simplifier
*/


  videoReadCallBack(datas)
  {

      console.log(datas)
      if (!Array.isArray(datas)) 
      {
        this.onQuit();
        return;
      }

      if (datas.length === 0)
      {
        this.onQuit();
        return;
      }


      

      //var newnodes = JSON.parse(JSON.stringify(this.state.nodes));
      var newnodes = structuredClone(this.state.nodes);

      this.mustRedraw = false;

      // on va mettre à jour nos nodes

      // download
      var ind = this.getIndex ("download")
      newnodes[ind].titleColor= "#007000";
      newnodes[ind].content  = [datas[0].viorifile];
      newnodes[ind].footer.type = "text";
      newnodes[ind].footer.text = {fr:"Terminé avec succès",en:"Done"};

      // analyse
      var ind = this.getIndex ("analyse")
      newnodes[ind].content  = [datas[0].vifile+"."+datas[0].viext];
      this.setTextStatusForNode(newnodes[ind], datas[0].visearchdata,datas[0].vierrorlibsearch,0,0);

      // conversion
      var ind = this.getIndex ("conversion")
      newnodes[ind].content  = [datas[0].vifile + "."+ datas[0].viext,
        datas[0].viconvfile + ".mp4"
        ];

      this.setTextStatusForNode(newnodes[ind], datas[0].viconv,datas[0].vierrorlibconv,datas[0].viconvpc,datas[0].viconvpid);
      


      // audio
      var ind = this.getIndex ("audio")
      newnodes[ind].content  = [datas[0].vixaudiofile1+".wf"];
      if (datas[0].vinbaudio === 2)
        newnodes[ind].content.push([datas[0].vixaudiofile2+".wf"]);
      if (datas[0].vixtr != -2)
        newnodes[ind].content.push([datas[0].vixtraudiofile+".mp3"]);

      this.setTextStatusForNode(newnodes[ind], datas[0].vixaudio,datas[0].vierrorlibaudio,datas[0].vixaudiopc,datas[0].vixaudiopid);


      // changements de plan
      var ind = this.getIndex ("changements")
      newnodes[ind].content  = [datas[0].vixcpfile + ".json",
        datas[0].vixcpfile + ".jpegs"
        ];

      this.setTextStatusForNode(newnodes[ind], datas[0].vixcp,datas[0].vierrorlibcp,datas[0].vixcppc,datas[0].vixcppid);
      this.setState ({nodes: newnodes})

      // recherche de textes
      var ind = this.getIndex ("recherche")
      newnodes[ind].content  = [datas[0].vixtexfile + ".json"];

      this.setTextStatusForNode(newnodes[ind], datas[0].vixtex,datas[0].vierrorlibtex,datas[0].vixtexpc,datas[0].vixtexpid);
      this.setState ({nodes: newnodes})

      // transcription
      var ind = this.getIndex ("transcription")

      var typetr = "Speechmatics";
      if (datas[0].vixtrtype !==0)
      {
        typetr="DAIA";
        if (datas[0].vixtr >= 0) typetr = typetr + " " + datas[0].vierrorlibtr; // dans ce cas error contient l'avancement
      }

      newnodes[ind].content  = [datas[0].vixtrfile + ".json", typetr];

      this.setTextStatusForNode(newnodes[ind], datas[0].vixtr,datas[0].vierrorlibtr,datas[0].vixtrpc,datas[0].vixtrpid);


      // scnerario
      var ind = this.getIndex ("scenario")
      newnodes[ind].content  = [datas[0].viscefile + ".json"]
      if (datas[0].visceasidpdf > 0 ) newnodes[ind].content.push("Document " + datas[0].visceasidpdf);
      this.setTextStatusForNode(newnodes[ind], datas[0].visce,datas[0].vierrorlibsce,datas[0].viscepc,datas[0].viscepid);


      // simplifier
      var ind = this.getIndex ("simplifier")
      newnodes[ind].content  = [datas[0].visimpfile + ".json"];
      this.setTextStatusForNode(newnodes[ind], datas[0].visimp,datas[0].vierrorlibsimp,datas[0].visimppc,datas[0].vixsimppid);


      // on fait la même chose pour les boutons

      newnodes.forEach(node =>{
              var disablebutton =
              {
                disableplay:true,
                disablestop:true,
                disablecancel:true,
              }

              if ((node.id !== "download") && (node.id !== "analyse"))
              {
                    disablebutton = this.getButtonStatus(newnodes, node.id, node.status);

                    var node = this.getNode(newnodes, node.id);

                    if ("play1" in node.buttons) node.buttons.play1.disabled = disablebutton.disableplay; 
                    if ("play2" in node.buttons) node.buttons.play2.disabled = disablebutton.disableplay;
                    if ("stop" in node.buttons) node.buttons.stop.disabled = disablebutton.disablestop;
                    if ("annuler" in node.buttons) node.buttons.annuler.disabled = disablebutton.disablecancel;

              }




      })



      newnodes.forEach(node =>{
        if ((node.status === -1) || (node.status === 0)) this.mustRedraw = true;

      })

      this.setState ({nodes: newnodes, video: datas[0]})

      if (this.mustRedraw) 
      {
          this.timer = setTimeout(() => {
            apiReadOneVideo ({viid: this.props.viid}, this.videoReadCallBack);
          }, 1200);
      }
      else
        this.timer = null;



  }

  getButtonStatus(lesnodes, name, status)
  {
      var disablebutton =
      {
        disableplay:true,
        disablestop:true,
        disablecancel:true,
      }



      if (status === -1) // a faire
        disablebutton.disablecancel = false;
      if (status === -2) // non demandé
        disablebutton.disableplay = false;
      if (status === -3) // terminer
        disablebutton.disableplay = false;

      if (status === 0) // en cours
        disablebutton.disablestop = false; // en cours on peut le stoppper
      
      if (status > 0)
        disablebutton.disableplay = false; // en erreur on peut quand même le relancer

      // maintenant on verifie qu'on peut vraiement les mettres en play

      var statusanalyse = 0;
      var statusconversion = 0;
      var statustranscription = 0;
      var statusscenario = 0;
      var statusaudio = 0;

      if (!disablebutton.disableplay)
      {
          // on vérifie que le worker avant est terminé ou à faire ou en cours
          switch (name)   
          {

              case "conversion":
                  statusanalyse = this.getNode(lesnodes, "analyse").status;
                  statusconversion = this.getNode(lesnodes, "conversion").status;
                  if ((statusanalyse > 0) || (statusconversion === -2)) // analyse en erreur ou pas de conversion
                    disablebutton.disableplay = true;
                  break;



              case "audio":
              case "recherche":
              case "changements": // lancable si convworker terminé ou à faire ou en cours
                                  // si non demandé alors simpleworker doit être terminé
                  statusconversion = this.getNode(lesnodes, "conversion").status;

                  if (statusconversion === -2) // non demandé on regarde simpleworker
                  {
                      statusanalyse = this.getNode(lesnodes, "analyse").status;
                      if (statusanalyse !== -3) // terminé
                        disablebutton.disableplay = true; // pas encore possible
                  }
                  else
                  {
                      // on a demandé sur conversion vidéo
                      if (statusconversion > 0) // convworker en erreur
                          disablebutton.disableplay = true; // pas possible, conversion en erreur
                  }

                  break;

              case "transcription": // lancable si audioworker terminé ou à faire ou en cours
                                  // si audioworker non demandé alors pas possible du tout
                  statusaudio = this.getNode(lesnodes, "audio").status;

                  if (statusaudio === -2) // non demandé pas possible
                        disablebutton.disableplay = true; // pas encore possible
                  else
                  {
                      // doit pas être en erreur
                      if (statusaudio > 0) // convworker en erreur
                          disablebutton.disableplay = true; // pas possible, audioworker en erreur
                  }

                  break;
            case "scenario": // lancabe si status transcription pas en erreur
                  statustranscription = this.getNode(lesnodes, "transcription").status;

                  if (statustranscription === -2) // non demandé pas possible
                        disablebutton.disableplay = true; // pas encore possible
                  else
                  {
                      // doit pas être en erreur
                      if (statustranscription > 0) // transcription  en erreur
                          disablebutton.disableplay = true; // pas possible, audioworker en erreur
                  }
                  break;


            case "simplifier": // lancabe si status transcription pas en erreur et sce pas en erreur
                  statusscenario = this.getNode(lesnodes, "scenario").status;

                  if (statusscenario === -2) // non demandé on regarde le status transcript
                  {
                        statustranscription = this.getNode(lesnodes, "transcription").status;
                        if ((statustranscription === -2) || (statustranscription > 0))
                        disablebutton.disableplay = true; // pas encore possible
                  }
                  else
                  {
                      // doit pas être en erreur
                      if (statusscenario > 0) // transcription  en erreur
                          disablebutton.disableplay = true; // pas possible, audioworker en erreur
                  }
                  break;



          }

      }

      return disablebutton;


}

  getWorkerName (id)
  {
    switch (id)
    {
        case "download" : return "";
        case "analyse" : return "simpleworker";
        case "conversion" : return "convworker";
        case "audio" : return "audioworker";
        case "changements" : return "cpworker" ;
        case "recherche" : return "textworker" ;
        case "transcription" : return "trworker" ;
        case "scenario" : return "sceworker" ;
        case "simplifier" : return "simpworker";
        default:
            alert (id)
    }
  }



  setTextStatusForNode(node, status, error, pc, pid)
  {



      node.pid = pid;
      node.status = status;
      if (status > 0) // en erreur
      {
        node.footer.type = "text";
        node.footer.text = {fr:error,en:error};
        node.titleColor = "#800000";
      }
      else
      {
          if (status === -3)
          {
              node.footer.type = "text";
              node.titleColor = "#007000";
              node.footer.text = {fr:"Terminé avec succès",en:"Done"};
          }
          else
          {
            if (status === -2)
            {
                node.footer.type = "text";
                node.footer.text = {fr:"Non demandé",en:"None"};
                node.titleColor = "#303030";
            }
            else
            {
              if (status === -1)
              {

                if (!("ppp" in node) )
                  node.ppp = ".";
                else
                {
                  node.ppp = node.ppp + ".";
                  if (node.ppp.length > 3) node.ppp = ".";
                }

                var ppp = node.ppp;
                node.footer.type = "text";
                node.footer.text = {fr:"En attente" + ppp,en:"Pending" + ppp};
                node.titleColor = "#0c0ca5";

              }
              else
              {
                if (status === 0)
                {
                    node.footer.type=  "progress";
                    node.footer.value= pc;
                    node.footer.progressColor=  "#000080"
                    node.titleColor = "#1c0cFF";

                }
              }
            }
          }
      }




  }

  getIndex (id)
  {
      for (var i=0; i < this.state.nodes.length; i++)
        if (this.state.nodes[i].id === id) return i;
      return -1;
  }

  getNode( lesnodes, id)
  {
    var ind = this.getIndex(id);
    if (ind === -1)
        alert(id)
    else
        return lesnodes[ind];
  }

  onValid()
  {
    
  }

  onQuit()
  {
    this.props.onButton("back", this.formulaire);    
  }

  
  handleButton(buttonkey)
  {
    
    this.props.onButton(buttonkey, this.formulaire);

    
  }

  onKillWorkerReturn(datas)
  {
    
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    apiReadOneVideo ({viid: this.props.viid}, this.videoReadCallBack);
  }


  handleGraphButton = (node, buttonId) => {

        console.log( "Node :", node.id," button ", buttonId);

        var worker = this.getWorkerName(node.id);
        console.log( "Node :", node.id," button ", buttonId," worker ", worker);

        if (buttonId === "annuler")
        {
            console.log("bouton cancel")
            const querycancel =  {viid: this.state.video.viid, worker: worker};
            ApiPostCancelWorker(querycancel,this.onKillWorkerReturn);
            return;
        }
        
        if (buttonId === "stop")
        {
            const querystop =  {viid: this.state.video.viid, worker: worker};
            ApiPostKillWorker(querystop,this.onKillWorkerReturn)
        }
            
        

        if ((buttonId === "play1") || (buttonId === "play2"))
        {
            // cas particulier trworker
            if ((worker === "trworker") && (buttonId === "play2")) worker = "mcaiworker";

            // on recherche le status du worker en amont
            var statusbefore = 0;
            switch (worker)   
            {

                case "convworker":
                statusbefore=  this.getNode(this.state.nodes,"analyse").status;
                break;

                case "cpworker":
                case "textworker":
                case "audioworker": 
                    statusbefore=  this.getNode(this.state.nodes,"conversion").status;
                    if (statusbefore === -2) // non demandé on regarde simpleworker
                        statusbefore=  this.getNode(this.state.nodes,"analyse").status
                    break;

                case "mcaiworker":
                case "trworker": 
                    statusbefore=  this.getNode(this.state.nodes,"audio").status;
                    break;

                case "sceworker":
                    statusbefore=  this.getNode(this.state.nodes,"transcription").status;
                    break;
                case "simpworker":
                    statusbefore=  this.getNode(this.state.nodes,"scenario").status;
                    if (statusbefore === -2) // non demandé on regarde transcription
                        statusbefore=  this.getNode(this.state.nodes,"transcription").status
                    break;

            }

            const query =  {viid: this.state.video.viid, worker: worker};
            console.log("status before ", statusbefore)
            if (statusbefore === -3)
            {
                ApiPostRestartWorker(query, this.onKillWorkerReturn);
            }
            else
            {
                ApiPostToDoWorker(query, this.onKillWorkerReturn);
            }

            
            

        }


        return;




        switch (buttonId) {

            case "play1":
                console.log("PLAY 1");
                break;

            case "play2":
                console.log("PLAY 2");
                break;

            case "stop":
                console.log("STOP");
                break;

            case "annuler":
                console.log("ANNULER");
                break;

            default:
                break;
        }
    };




  render()
  {
    this.maxwidth =  (window.innerWidth * 90)/100;
    if (this.maxwidth > 1800) this.maxwidth = 1800;

    this.maxheight =  (window.innerHeight * 70)/100;
    if (this.maxheight > 550) this.maxheight = 550;

    
    var retour = [<></>];
    if (this.props.display)
    {

        retour =
        (
          <div style = {{width:this.maxwidth, height: this.maxheight}}>

                <Graph
                    nodes={this.state.nodes}
                    lang = {this.context.language}
                    onNodeButtonClick={
                        this.handleGraphButton
                    }
                />
          </div>
        )
      }
    return super.render(retour);
  }


}


GraphVideo.defaultProps = 
{ 
  viid:0,
}


export default GraphVideo;